import { formatToDecimals } from '@lib/helpers/formatting';
import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { StatisticsType } from './SummaryExternalSupplies';

interface ExecutionSummaryProgressCardProps {
	statistics: StatisticsType | undefined;
}

const ExecutionSummaryProgressCard: React.FC<ExecutionSummaryProgressCardProps> = ({ statistics }) => {
	return (
		<div
			style={{
				backgroundColor: '#EDF0F7',
				padding: '1.5rem',
				borderRadius: '8px',
				height: '100%',
				display: 'grid',
				gap: '1rem',
			}}
		>
			<h3
				style={{
					fontSize: '18px',
					fontWeight: 700,
				}}
			>
				Catene documentali controllate assegnate a me
			</h3>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					fontWeight: 700,
				}}
			>
				<span>
					{statistics?.checkAssignedCompleted ?? 0}/{statistics?.totalAssignedInvoices ?? 0}
				</span>
				<span>{formatToDecimals(statistics?.percentageAssignedCompleted, 0)}%</span>
			</div>
			<ProgressBar
				className={`new ${statistics?.percentageAssignedCompleted === 100 ? 'green' : 'blue'} progress`}
				now={statistics?.percentageAssignedCompleted ?? 0}
				label={`${formatToDecimals(statistics?.percentageAssignedCompleted, 0)}%`}
				visuallyHidden
			/>
		</div>
	);
};

export default ExecutionSummaryProgressCard;
